<template>
  <Dialog :visible="showAssessmentDialog" modal
     :style="{ width: '25rem' }" class="mx-4">
    <div class="flex flex-col items-center justify-evenly gap-5">
      <DatePicker
        v-model="selectedDateTime"
        :dateFormat="PRIMEVUE_DATE_FORMAT"
        :placeholder="LOCALE_DATETIME_PLACEHOLDER"
        showTime
        hourFormat="24"
        class="w-full py-3"
        showIcon
        iconDisplay="input"
      />
      <button @click="createTask" class="bg-[var(--color-orange)] text-white rounded-xl text-lg py-3
        px-9">
        {{ $t("UserAdministrationComponent.options.createAssessment") }}
      </button>
    </div>
  </Dialog>
</template>

<script>
import NetworkAdmin from '@/helpers/networking/NetworkAdmin';
import { Dialog } from 'primevue';
import DatePicker from 'primevue/datepicker';
import {
  PRIMEVUE_DATE_FORMAT,
  LOCALE_DATETIME_PLACEHOLDER,
} from '@/helpers/formatLocaleDate';

export default {
  name: 'CreateAssessmentCalendarOverlayComponent',
  props: {
    data: Object,
    showAssessmentDialog: Boolean,
  },
  components: { Dialog, DatePicker },
  data() {
    return {
      selectedDateTime: new Date(),
      PRIMEVUE_DATE_FORMAT,
      LOCALE_DATETIME_PLACEHOLDER,
    };
  },
  methods: {
    async createTask() {
      try {
        const postData = {
          userIDs: [...this.data.userIDs],
          schemaName: this.data?.schemaName,
          schemaID: this.data?.schemaID,
          startingTime: new Date(this.selectedDateTime).toUTCString(),
          forceSimilarTask: true,
        };
        await NetworkAdmin.createTask(postData);

        this.$toast.add({
          severity: 'success',
          summary: this.$t('UserAdministrationComponent.toast.successfulTaskCreation'),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        const roleDeniedHandled = await this.$store.dispatch(
          'assessmentRoleDenied/maybeShowFromApiError',
          error,
          { root: true },
        );
        if (!roleDeniedHandled) {
          this.$toast.add({
            severity: 'error',
            summary: this.$t('UserAdministrationComponent.toast.errorTaskCreation'),
            detail: '',
            life: 3000,
          });
        }
      }
      this.$emit('update:visible', false);
    },
  },
};
</script>
